import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Tooltip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getBannerMessageByKey } from "../../../../Services/helper";
import { AutoPayDivider, StyledCard } from "../../../../Styles/GlobalStyles";
 
const SurchargePaymentSummary = ({ totalAmountWithTax, taxAmount, enteredAmount }: any) => {
  const sideCoreBannerMessages = useSelector(
    (state: any) => state?.sideCoreContent?.bannerMessages
  );
  const SURCHARGE_BANNER_TEXT = getBannerMessageByKey(
    "surcharge-banner-make-payment",
    sideCoreBannerMessages
  );
 
  return (
    <StyledCard>
      <Typography
        variant="h6"
        fontWeight={"bold"}
        sx={(theme) => ({ color: theme.palette.customcolor.cardHeading, mb: 2 })}>
        Payment Summary
      </Typography>
 
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
        <Typography sx={(theme) => ({ color: theme.palette.customcolor.footerTextColor })}>
          Entered Amount
        </Typography>
        <Typography sx={(theme) => ({ color: theme.palette.customcolor.footerTextColor })}>
          ${parseFloat(enteredAmount).toFixed(2)}
        </Typography>
      </Box>
 
      <AutoPayDivider />
 
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={1.5} mb={2.3}>
        <Box display="flex" alignItems="center">
          <Typography sx={(theme) => ({ color: theme.palette.customcolor.footerTextColor })}>
            Credit Card Transaction Fee
          </Typography>
          <Tooltip title={SURCHARGE_BANNER_TEXT?.content?.subheading?.[0]?.text}>
            <InfoOutlinedIcon
              sx={(theme) => ({
                ml: 0.5,
                fontSize: 18,
                color: theme.palette.customcolor.footerTextColor,
              })}
            />
          </Tooltip>
        </Box>
        <Typography sx={(theme) => ({ color: theme.palette.customcolor.footerTextColor })}>
          ${parseFloat(taxAmount).toFixed(2)}
        </Typography>
      </Box>
 
      <AutoPayDivider />
 
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
        <Typography
          variant="h6"
          fontWeight={"bold"}
          sx={(theme) => ({ color: theme.palette.customcolor.footerTextColor })}>
          Total Amount
        </Typography>
        <Typography
          variant="h6"
          color={"secondary"}
          fontWeight={"bold"}
          sx={(theme) => ({ color: theme.palette.secondary.main })}>
          ${parseFloat(totalAmountWithTax).toFixed(2)}
        </Typography>
      </Box>
    </StyledCard>
  );
};
 
export default SurchargePaymentSummary;